module.exports = __webpack_public_path__ + "img/tabbar01.1e0c81c2.png";